/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonTokenListRequest = {
    sortField?: BabylonTokenListRequest.sortField;
    sortDirection?: BabylonTokenListRequest.sortDirection;
    tokenTypeList?: Array<'CW20' | 'IBC' | 'NATIVE'>;
    page?: number;
    size?: number;
};

export namespace BabylonTokenListRequest {

    export enum sortField {
        PRICE = 'PRICE',
        MARKET_CAP = 'MARKET_CAP',
        VOLUME = 'VOLUME',
        HOLDER = 'HOLDER',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

